/* INSTALADOR DE FIRMWARE — o motor.
 *
 * POR QUE NAO E MAIS O ESP WEB TOOLS. O `<esp-web-install-button>` e dono do
 * fluxo inteiro: dialogo, barra e console sao dele, dentro do shadow root
 * dele. Barra com mascote, passo de WiFi automatico e console com linha de
 * comando so existem falando com o `esptool-js` direto, que e a biblioteca que
 * o proprio ESP Web Tools usa por baixo.
 *
 * O QUE ISSO CUSTOU E O QUE GANHOU. Some a traducao por interceptacao e o CSS
 * injetado em shadow root — o dialogo da biblioteca deixa de existir. Em
 * troca, o passo a passo, os textos e as cores viram markup e folha comuns.
 *
 * A SENHA DO WIFI NAO SAI DAQUI. Vai do campo para a porta USB, e nao ha fetch
 * nenhum com ela. Fica guardada no proprio navegador quando a pessoa marca
 * "lembrar", e so ali - veja o bloco de armazenamento mais abaixo.
 */

import { serialPorUsb } from './nt-usb-serial.js';

const CDN = 'https://unpkg.com/esptool-js@0.5.7/bundle.js';

/* DE ONDE VEM A PORTA.
 *
 * No computador e a Web Serial. No Android ela nao existe, e a casca de WebUSB
 * entrega um objeto do mesmo formato - o resto do arquivo nao precisa saber
 * qual dos dois esta em uso, e por isso a escolha acontece aqui, uma vez.
 *
 * `null` quer dizer aparelho sem nenhuma das duas: iPhone, Firefox, Safari. */
const SERIAL = ('serial' in navigator) ? navigator.serial : serialPorUsb();

/* Quanto silencio esperar antes de concluir que o aperto de mao de "sai do
   modo flash" nao vem. Enquanto grava, o progresso avisa a cada bloco; oito
   segundos sem nenhum aviso so acontecem quando algo parou. */
const ESPERA_SAIDA = 5000;

/* Teto absoluto da gravacao inteira. Existe para a pagina nunca mais ficar
   presa por um motivo que eu ainda nao vi: cinco minutos e muito acima dos
   onze segundos que uma gravacao leva de verdade. */
const TETO_GRAVACAO = 300000;

/* Quanto esperar pelo pedido de reinicio. Se o chip obedecer, ele reinicia e
   nao responde nada - entao estourar este prazo e o resultado BOM. */
const ESPERA_REINICIO = 4000;

/* Quanto o tracker leva para subir depois do reinicio. Mandar o WiFi antes
   disso e falar com quem ainda nao esta ouvindo. */
const ESPERA_BOOT = 10000;

/* A primeira linha que o firmware imprime ao acordar. E o sinal de verdade de
   que ele subiu; os dez segundos sao so a media. */
const MARCA_BOOT = '[SlimeVR]';

/* Quanto tempo procurar a porta depois do reinicio. O tracker some do
   barramento e volta como aparelho novo, e o sistema leva um instante para
   enumera-lo de novo - doze segundos cobrem com folga uma reconexao de USB. */
const ESPERA_PORTA = 12000;

/* Uint8Array para "binary string": e o formato que o writeFlash espera.
   Em pedacos porque `apply` com 1,3 milhao de argumentos estoura a pilha. */
function paraBinaria(bytes) {
  var pedaco = 0x8000;
  var partes = [];
  for (var i = 0; i < bytes.length; i += pedaco) {
    partes.push(String.fromCharCode.apply(null, bytes.subarray(i, i + pedaco)));
  }
  return partes.join('');
}

/* ONDE A REDE FICA GUARDADA.
 *
 * Quem grava dez trackers seguidos digita a mesma rede dez vezes, e a senha de
 * WiFi nao e curta. Entao ela fica no navegador, e nao volta para servidor
 * nenhum.
 *
 * FICA ATRAS DE UM VISTO, e o visto vale tambem para a senha. localStorage e
 * lido por QUALQUER script da mesma origem, e uma loja Shopify carrega script
 * de aplicativo de terceiro em toda pagina. Guardar senha de WiFi ali sem
 * avisar seria decidir pela pessoa um risco que e dela.
 *
 * Desmarcar apaga na hora, e nao so para de gravar dali em diante.
 */
const CHAVE = 'nt-instalador-rede';

function lerRede() {
  try {
    var cru = localStorage.getItem(CHAVE);
    return cru ? JSON.parse(cru) : null;
  } catch (e) { return null; }
}

function gravarRede(dados) {
  try {
    if (dados) localStorage.setItem(CHAVE, JSON.stringify(dados));
    else localStorage.removeItem(CHAVE);
  } catch (e) { /* aba anonima ou armazenamento bloqueado: segue sem lembrar */ }
}

class Instalador {
  constructor(raiz) {
    this.raiz = raiz;
    this.d = raiz.dataset;
    this.modelo = null;
    this.porta = null;
    this.transporte = null;
    this.loader = null;
    this.lendo = false;

    this.q = (s) => raiz.querySelector(s);
    this.qq = (s) => Array.from(raiz.querySelectorAll(s));

    this.ssid = this.q('[data-nt-ssid]');
    this.senha = this.q('[data-nt-senha]');
    this.botao = this.q('[data-nt-instalar]');
    this.status = this.q('[data-nt-status]');
    this.barra = this.q('[data-nt-barra]');
    this.preencher = this.q('[data-nt-preencher]');
    this.pct = this.q('[data-nt-pct]');
    this.console = this.q('[data-nt-console]');
    this.linha = this.q('[data-nt-comando]');

    this.lembrar = this.q('[data-nt-lembrar]');

    this.verBotao = this.q('[data-nt-verificar]');
    this.verStatus = this.q('[data-nt-ver-status]');
    this.verGravar = this.q('[data-nt-ver-gravar]');
    this.procurando = this.q('[data-nt-procurando]');
    this.mascote = this.q('.nt-inst__mascote');
    this.acabou = false;

    this.ligar();
    this.recuperarRede();
    this.sincronizar();
  }

  ligar() {
    this.qq('[data-nt-modelo]').forEach((r) => {
      r.addEventListener('change', () => this.sincronizar());
    });



    [this.ssid, this.senha].forEach((c) => {
      if (c) c.addEventListener('input', () => { this.sincronizar(); this.guardarRede(); });
    });

    if (this.lembrar) {
      this.lembrar.addEventListener('change', () => this.guardarRede());
    }

    if (this.botao) this.botao.addEventListener('click', () => this.instalar());

    /* A verificacao so comeca no clique: `requestPort` exige gesto humano, e
       chamar no carregamento da pagina nem abriria a caixa de portas. */
    if (this.verBotao) {
      this.verBotao.addEventListener('click', () => this.verificar());
      /* SEM WEB SERIAL, O BOTAO NAO EXISTE. Firefox, Safari e qualquer
         navegador de celular nao tem a API: deixar o botao ali para dar erro
         no clique seria pior que dizer de saida o que fazer. */
      if (!SERIAL) {
        this.verBotao.hidden = true;
        this.verDizer(this.d.msgVerSemSuporte);
      }
    }
    if (this.verGravar) {
      this.verGravar.addEventListener('click', () => {
        var passo = this.q('[data-nt-passo1]');
        this.rolarAte(passo);
      });
    }

    var enviar = this.q('[data-nt-enviar-comando]');
    if (enviar) enviar.addEventListener('click', () => this.mandarComando());
    if (this.linha) {
      this.linha.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); this.mandarComando(); }
      });
    }

    var proximo = this.q('[data-nt-proximo]');
    if (proximo) proximo.addEventListener('click', () => this.proximoTracker());

    var reabrir = this.q('[data-nt-reabrir]');
    if (reabrir) reabrir.addEventListener('click', () => this.continuarWifi());

    var tentar = this.q('[data-nt-tentar]');
    if (tentar) tentar.addEventListener('click', () => { this.etapa('escolher'); this.dizer(''); });
  }

  /* O BOTAO DE INSTALAR SO NASCE COM AS DUAS COISAS PRONTAS: modelo escolhido e
     rede preenchida. Aparecer antes seria oferecer um caminho que trava na
     metade — a pessoa grava, o tracker perde a rede salva e ela descobre ali
     que precisava do WiFi que ninguem pediu. */
  sincronizar() {
    /* O MODELO E LIDO DO DOM, e nao guardado quando o `change` acontece.
     *
     * O navegador restaura o formulario ao recarregar: o radio volta marcado
     * sem disparar `change`. Guardando so no evento, `modelo` ficava nulo e a
     * pessoa via o cartao escolhido, a rede preenchida, nenhum botao, e a
     * pagina pedindo que escolhesse o modelo que estava ali na frente dela.
     *
     * Lendo o DOM a cada sincronia nao existe estado paralelo para
     * dessincronizar - o que esta marcado na tela e o que vale. */
    var r = this.qq('[data-nt-modelo]').filter((x) => x.checked)[0];
    this.modelo = r ? {
      nome: r.dataset.ntNome || '',
      manifesto: r.dataset.ntManifesto || '',
    } : null;

    var temModelo = !!(this.modelo && this.modelo.manifesto);
    var temRede = !!(this.ssid && this.ssid.value.trim());
    var pronto = temModelo && temRede;

    this.raiz.classList.toggle('is-pronto', pronto);
    if (this.botao) this.botao.hidden = !pronto;

    var falta = this.q('[data-nt-falta]');
    if (falta) {
      falta.hidden = pronto;
      if (!pronto) {
        falta.textContent = !temModelo ? this.d.msgFaltaModelo : this.d.msgFaltaRede;
      }
    }
  }

  recuperarRede() {
    var salvo = lerRede();
    if (!salvo) return;
    if (this.ssid && salvo.ssid) this.ssid.value = salvo.ssid;
    if (this.senha && salvo.senha) this.senha.value = salvo.senha;
    if (this.lembrar) this.lembrar.checked = true;
  }

  guardarRede() {
    if (!this.lembrar || !this.lembrar.checked) { gravarRede(null); return; }
    gravarRede({
      ssid: this.ssid ? this.ssid.value : '',
      senha: this.senha ? this.senha.value : '',
    });
  }

  /* LEVA A PAGINA ATE O CARTAO DO PROGRESSO.
   *
   * Tres coisas que a primeira versao errou, todas juntas:
   *
   * Rolava no CLIQUE, antes de a janela de portas abrir - e nessa hora o
   * cartao ainda esta escondido, entao a conta era feita sobre um elemento de
   * altura zero. Agora rola quando o cartao aparece.
   *
   * Mirava o `<pre>` com `block: 'center'`. O console nasce vazio e cresce ate
   * 320px enquanto grava, entao centrar uma caixa que vai crescer joga a
   * pagina alem do ponto: o topo do console ficava acima da dobra.
   *
   * E o cabecalho e fixo no topo. `scrollIntoView` nao sabe disso e entrega o
   * elemento embaixo dele; por isso a conta e a mao, descontando a altura real
   * do cabecalho. */
  rolarAte(el) {
    if (!el) return;
    var topo = document.querySelector('.nt-header');
    /* o cabecalho fixo fica abaixo da barra de aviso (top: --nt-bar-h): a borda de baixo dele ja soma as duas alturas */
    var folga = (topo ? Math.max(topo.getBoundingClientRect().bottom, 0) : 0) + 24;
    window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - folga,
      behavior: 'smooth',
    });
  }

  etapa(nome) {
    this.raiz.dataset.etapa = nome;

    /* Dali em diante tudo que interessa acontece neste cartao - barra, console,
       erro. Sem trazer a pagina, a pessoa fica olhando o botao sem ver que
       alguma coisa comecou. */
    /* MIRA O TOPO DA SECAO INTEIRA, e nao o botao nem o console.
     *
     * Ao sair de 'escolher' os tres cartoes de cima somem: a secao encolhe de
     * ~1670px para ~800px e o botao sobe mais de mil pixels. Mirar qualquer
     * coisa la dentro obrigava a pagina a descer muito para alcancar um alvo
     * que, depois do encolhimento, ja estava perto do topo.
     *
     * Com a secao encolhida ela cabe inteira numa tela. Entao o alvo certo e
     * ela: botao, barra e console aparecem juntos, e a pagina desce so o
     * necessario para tirar a capa do caminho. */
    if (nome === 'gravando') {
      this.rolarAte(this.raiz.closest('[data-nt-fx], .nt-sec') || this.raiz);
    }
    var rot = this.q('[data-nt-etapa-rotulo]');
    if (!rot) return;
    if (nome === 'gravando') rot.textContent = this.d.etapa1;
    else if (nome === 'wifi') rot.textContent = this.d.etapa2;
    else rot.textContent = '';
  }

  dizer(txt) {
    if (this.status) this.status.textContent = txt || '';
  }

  escrever(txt) {
    if (!this.console) return;
    this.console.textContent += txt;
    this.console.scrollTop = this.console.scrollHeight;
  }

  /* ESPERAR COM PRAZO, porque aqui quase toda espera pode nao voltar.
   *
   * Devolve 'ok', 'erro' ou 'prazo'. O terceiro nao e falha: mandar um chip
   * reiniciar e depois aguardar a confirmacao dele e pedir carta de quem ja
   * saiu da sala. */
  comPrazo(promessa, ms) {
    return Promise.race([
      promessa.then(() => 'ok', () => 'erro'),
      new Promise((r) => setTimeout(() => r('prazo'), ms)),
    ]);
  }

  progresso(feito, total) {
    var p = total ? Math.round((feito / total) * 100) : 0;
    if (this.barra) this.barra.style.setProperty('--nt-prog', p + '%');
    if (this.pct) this.pct.textContent = p + '%';
  }

  async instalar() {
    /* GUARDA DE ENTRADA. O botao ja nao aparece sem modelo, mas ele so nao
       aparecia por CSS - e foi exatamente isso que falhou uma vez, com
       `.nt-cta` declarando display e vencendo o atributo `hidden`. Uma regra
       de estilo nao e lugar de guardar uma condicao; aqui e. */
    if (!this.modelo || !this.modelo.manifesto) { this.falhar(new Error(this.d.msgSemModelo)); return; }
    if (!this.ssid || !this.ssid.value.trim()) { this.falhar(new Error(this.d.msgFaltaRede)); return; }
    if (!SERIAL) { this.falhar(new Error(this.d.msgNavegador)); return; }

    /* A PORTA VEM ANTES DA BIBLIOTECA, e a ordem e o bug.
     *
     * `requestPort` exige ativacao transitoria: o gesto da pessoa, que vale por
     * poucos segundos. Eu baixava o esptool-js primeiro - duzentos kilobytes -
     * e so entao pedia a porta. No computador o arquivo vem do cache em
     * milissegundos e passa; num celular em rede movel o gesto expira no meio
     * do download, e o navegador recusa a caixa de portas SEM ERRO VISIVEL.
     *
     * Era por isso que no Android nao aparecia opcao nenhuma para conectar.
     * Pedir a porta primeiro custa nada e nao depende de rede. */
    try {
      this.dizer(this.d.msgEscolher);
      this.porta = await SERIAL.requestPort();
    } catch (e) {
      /* Fechar a janela de portas nao e erro: a pessoa so desistiu. */
      this.dizer('');
      return;
    }

    var mod;
    try {
      this.dizer(this.d.msgCarregando);
      mod = await import(CDN);
    } catch (e) {
      this.dizer(this.d.msgSemBiblioteca);
      return;
    }

    this.etapa('gravando');
    this.progresso(0, 1);
    if (this.console) this.console.textContent = '';

    /* O TERMINAL E O MEU MELHOR SENSOR. A biblioteca escreve "Leaving..." por
       aqui, uma linha antes de fazer o pedido que nunca volta - entao e este
       callback, e nao o progresso, que sabe o instante exato em que a espera
       comeca.

       As duas tentativas anteriores erraram por medir outra coisa: primeiro os
       100%, que podem nunca ser reportados, depois o silencio do progresso, que
       depende de ele ser chamado durante a gravacao. O texto do console eu vejo
       com os proprios olhos na tela - e o unico sinal que ja provei existir. */
    var viuSaida = 0;
    var olhar = (t) => {
      if (!viuSaida && String(t).indexOf('Leaving') !== -1) viuSaida = Date.now();
    };
    var terminal = {
      clean: () => { if (this.console) this.console.textContent = ''; },
      writeLine: (t) => { olhar(t); this.escrever(t + '\n'); },
      write: (t) => { olhar(t); this.escrever(t); },
    };

    try {
      this.transporte = new mod.Transport(this.porta, true);
      this.loader = new mod.ESPLoader({
        transport: this.transporte,
        baudrate: 921600,
        romBaudrate: 115200,
        terminal: terminal,
      });

      this.dizer(this.d.msgConectando);
      await this.loader.main();

      this.dizer(this.d.msgBaixando);
      var man = await fetch(this.modelo.manifesto).then((r) => r.json());
      var parte = man.builds[0].parts[0];
      var bytes = new Uint8Array(await fetch(parte.path).then((r) => r.arrayBuffer()));

      this.dizer(this.d.msgGravando);

      /* O PRAZO PARA O "Leaving..." e a peca central deste arquivo.

         O `writeFlash` termina assim, na propria biblioteca:

           this.info("Leaving...");
           this.IS_STUB && (await this.flashBegin(0,0), await this.flashDeflFinish())

         Nestes trackers a promessa nunca resolve: o aperto de mao de "sair do
         modo flash" nao volta pelo USB-JTAG, e a pagina ficava presa em
         "Leaving..." para sempre.

         OS BYTES JA ESTAO GRAVADOS quando isso acontece - o console imprime o
         total escrito uma linha antes. O que falta e so o aviso de saida, e
         esperar por ele indefinidamente troca uma gravacao concluida por uma
         tela travada.

         `main()` sempre sobe o stub, sem opcao de desligar, entao nao da para
         evitar o bloco.

         O PRAZO CONTA SILENCIO, e nao a chegada aos 100%. A primeira versao
         disto so armava quando `reportProgress` fosse chamado com
         `feito === total`, e a biblioteca nao garante essa ultima chamada: sem
         ela o prazo nunca armava e o laco girava para sempre - o mesmo travamento
         com mais codigo.

         Agora cada aviso de progresso renova o relogio. Enquanto grava eles
         chegam a cada bloco, entao nunca dispara por engano; quando param e
         nada mais volta, sao os 8 segundos de silencio que dizem que o aperto
         de mao nao vem. E o relogio so arma DEPOIS do primeiro aviso, porque
         apagar a flash antes do primeiro bloco pode demorar. */
      var ultimoAviso = 0;
      var acabou = false;
      var promessa = this.loader.writeFlash({
        fileArray: [{ data: paraBinaria(bytes), address: parte.offset || 0 }],
        flashSize: 'keep',
        eraseAll: false,
        compress: true,
        reportProgress: (_i, feito, total) => {
          this.progresso(feito, total);
          ultimoAviso = Date.now();
        },
      });
      promessa.then(() => { acabou = true; }, () => { acabou = true; });

      /* TRES REDES, da mais precisa para a mais grosseira, porque ja escolhi
         uma so duas vezes e as duas falharam:
           1. viu "Leaving..." e passou o prazo — o caso conhecido;
           2. o progresso emudeceu — se a saida nem chegar a ser anunciada;
           3. teto absoluto — para a pagina nunca mais ficar presa por um
              motivo que eu ainda nao vi. */
      var respondeu = true;
      var comecou = Date.now();
      while (!acabou) {
        await new Promise((r) => setTimeout(r, 200));
        var agora = Date.now();
        if (viuSaida && agora - viuSaida > ESPERA_SAIDA) { respondeu = false; break; }
        if (ultimoAviso && agora - ultimoAviso > ESPERA_SAIDA * 3) { respondeu = false; break; }
        if (agora - comecou > TETO_GRAVACAO) { respondeu = false; break; }
      }

      this.progresso(1, 1);
      if (!respondeu) this.escrever('\n' + (this.d.msgSaidaMuda || '') + '\n');

      /* REINICIAR DEPOIS DE GRAVAR: a parte que mais custou a acertar, e por um
         motivo que nao estava em lugar nenhum que eu olhei primeiro.

         O `writeFlash` do esptool-js TERMINA MANDANDO O CHIP FICAR NO
         BOOTLOADER. O fim dele e `flashDeflFinish()`, e a assinatura e
         `flashDeflFinish(reboot = false)` que envia `reboot ? 0 : 1`, onde 1
         quer dizer "fique onde esta". Nenhum reset por fora ia adiantar: o
         stub estava obedecendo uma ordem de nao sair.

         Antes eu tentei dois caminhos errados pelo mesmo motivo de nao ter
         lido isto: `after('hard_reset')`, que so faz setRTS e nestes trackers
         nao vai a lugar nenhum porque sao USB-JTAG nativo; e mandar REBOOT
         pela serial, que nao podia funcionar porque no bootloader nao ha
         firmware para ler comando.

         O certo e repetir o fim da gravacao com reboot = true. E um comando
         para o stub que ja esta rodando, sem depender de pino nenhum. */
      /* PEDIR PARA REINICIAR NAO TEM RESPOSTA, e foi aqui que a pagina ficava
         presa - no meu codigo, e nao na biblioteca.

         `flashDeflFinish(true)` manda o chip reiniciar e DEPOIS espera a
         confirmacao dele. O chip reinicia e nunca responde, porque reiniciou.
         Os prazos que eu tinha posto guardavam a espera anterior, a do
         `writeFlash`, e nao esta: quando o writeFlash terminava normalmente,
         eu escapava daquele laco e caia direto neste await eterno.

         Entao os dois caminhos vao com prazo, e prazo aqui NAO e falha: e o
         sintoma esperado de o comando ter funcionado. */
      this.dizer(this.d.msgReiniciando);
      try {
        if (respondeu && this.loader.IS_STUB) {
          await this.comPrazo(
            (async () => {
              await this.loader.flashBegin(0, 0);
              await this.loader.flashDeflFinish(true);
            })(),
            ESPERA_REINICIO
          );
        } else {
          /* O stub nem respondeu ao "sair"; pedir "reinicie" pela mesma via nao
             levaria a nada. Sobra a sequencia de pinos. */
          await this.comPrazo(
            new mod.UsbJtagSerialReset(this.transporte).reset(),
            ESPERA_REINICIO
          );
        }
      } catch (e) { /* o proximo passo diz se pegou */ }

      /* REINICIAR DERRUBA A PORTA, e o handle nao volta a vida. Em USB nativo o
         tracker some do barramento e volta como DISPOSITIVO NOVO: o objeto que
         o navegador nos deu passa a apontar para algo que nao existe mais.

         Reabrir o mesmo handle, que era o que eu tentava aqui, nunca podia dar
         certo. O caminho e procurar a porta de novo - e a permissao ja foi
         concedida, entao isso nao pede clique nenhum. */
      var voltou = await this.reencontrarPorta(mod, ESPERA_PORTA);

      if (!voltou) {
        /* A porta nao voltou sozinha. Em vez de morrer aqui, o fluxo pede a
           porta de novo: o firmware ja esta gravado, e o que falta e so o WiFi. */
        this.etapa('reabrir');
        this.dizer(this.d.msgReabrir);
        return;
      }

      /* Nada de REBOOT aqui. Com o firmware ja de pe o comando o reiniciaria de
         novo, derrubando a porta uma segunda vez no meio do passo do WiFi. Ele
         continua a mao, na linha de comando do console. */

      /* PASSO 2 SOZINHO, depois da gravacao concluida. A gravacao apagou a rede
         salva; pedir para a pessoa clicar de novo aqui seria cobrar por um
         problema que nos criamos. */
      await this.mandarWifi(true);

      this.etapa('console');
      this.ouvirPorta();
    } catch (e) {
      this.falhar(e);
      await this.desligar();
    }
  }

  falhar(e) {
    this.etapa('erro');
    var alvo = this.q('[data-nt-erro]');
    var txt = (this.d.msgErro || 'Erro') + ' ' + (e && e.message ? e.message : e);
    if (alvo) alvo.textContent = txt;
    this.dizer(txt);
  }

  verDizer(txt) {
    if (this.verStatus) this.verStatus.textContent = txt || '';
  }

  /* VERIFICAR A VERSAO GRAVADA NO TRACKER.
   *
   * Abre a porta por conta propria em vez de usar o Transport do gravador: sao
   * conversas diferentes e momentos diferentes, e o gravador so existe depois
   * que a pessoa escolhe modelo e rede.
   *
   * COMPARA SO O PREFIXO NUMERICO. O firmware se apresenta como
   * "1.5 - NOVATRACKER" e o sufixo muda entre builds; comparar a linha inteira
   * acusaria desatualizado em tracker que esta em dia.
   */
  async verificar() {
    if (!SERIAL) { this.verDizer(this.d.msgVerSemSuporte); return; }

    var porta;
    try {
      porta = await SERIAL.requestPort();
    } catch (e) { return; }

    this.verDizer(this.d.msgVerLendo);
    if (this.verGravar) this.verGravar.hidden = true;

    var texto = '';
    var deuRuim = false;
    try {
      await porta.open({ baudRate: 115200 });

      var w = porta.writable.getWriter();
      try {
        await w.write(new TextEncoder().encode('GET TEST' + String.fromCharCode(10)));
      } finally { w.releaseLock(); }

      var r = porta.readable.getReader();
      var dec = new TextDecoder();
      var fim = Date.now() + 3000;
      try {
        while (Date.now() < fim && texto.indexOf('[TEST] Board:') === -1) {
          var t = await Promise.race([
            r.read(),
            new Promise((res) => setTimeout(() => res(null), Math.max(0, fim - Date.now()))),
          ]);
          if (t && t.value) texto += dec.decode(t.value, { stream: true });
        }
      } finally {
        /* `cancel` antes de soltar: a ultima leitura pode ter ficado pendurada
           no prazo, e soltar a trava com leitura pendente da erro. */
        try { await r.cancel(); } catch (e) {}
        r.releaseLock();
      }
    } catch (e) {
      deuRuim = true;
    }

    /* A PORTA TEM DE FECHAR AQUI. Ela e uma so: enquanto esta aberta para a
       verificacao, o gravador nao consegue abri-la, e a pessoa levaria um erro
       sem entender que fomos nos que ficamos com ela na mao. */
    try { await porta.close(); } catch (e) {}

    if (deuRuim) { this.verDizer(this.d.msgVerErro); return; }

    var achou = texto.match(/firmware:\s*(.+?),\s*address:/);
    if (!achou) { this.verDizer(this.d.msgVerMudo); return; }

    var atual = (achou[1].trim().match(/^([\d.]+)/) || [])[1] || '';

    var alvo;
    try {
      alvo = await fetch(this.d.verFonte, { cache: 'no-store' }).then((x) => x.json());
    } catch (e) { this.verDizer(this.d.msgVerErro); return; }

    var nova = String(alvo.versao || '');
    if (atual && nova && atual === nova) {
      this.verDizer((this.d.msgVerAtualizado || '').replace('{v}', atual));
      return;
    }
    this.verDizer(
      (this.d.msgVerDesatualizado || '')
        .replace('{atual}', atual || '?')
        .replace('{nova}', alvo.nome || nova)
    );
    if (this.verGravar) this.verGravar.hidden = false;
  }

  /* FALAR COM O FIRMWARE E FALAR EM TEXTO PURO.
   *
   * O `write` do Transport nao escreve o que a gente da: ele passa tudo pelo
   * slipWriter, que embrulha os bytes num quadro SLIP - um 0xC0 na frente e
   * outro atras. Isso e o certo para conversar com o bootloader, que era o
   * unico interlocutor que a biblioteca tinha em mente, e e justamente o
   * errado para conversar com o firmware ja de pe.
   *
   * Era esta a falha que sobrou: o tracker recebia 0xC0 SET WIFI ... 0xC0, o
   * primeiro byte sujava o comando e o parser descartava a linha inteira. Do
   * nosso lado nada acusava nada, porque o envio funcionava - o que nao
   * chegava era o SENTIDO.
   *
   * Entao escrevo direto na porta, sem passar pelo Transport. */
  async escreverLinha(txt) {
    var w = this.porta.writable.getWriter();
    try {
      await w.write(new TextEncoder().encode(txt));
    } finally {
      w.releaseLock();
    }
  }

  /* PROCURAR A PORTA DE NOVO DEPOIS DO REINICIO.
   *
   * O tracker volta como dispositivo novo, entao o que interessa nao e o
   * handle antigo e sim qualquer porta ja autorizada que ACEITE ABRIR. A
   * permissao continua valendo para o mesmo aparelho, e por isso nada disto
   * pede clique: `requestPort` precisa de gesto humano, `getPorts` nao.
   *
   * O evento `connect` e o sinal mais preciso - ele avisa no instante em que o
   * aparelho reaparece. A varredura por `getPorts` fica ao lado dele porque o
   * evento pode chegar antes de eu comecar a escutar, ou nao chegar.
   *
   * O teste de "serve" e tentar abrir: handle morto falha na hora, e isso
   * separa o velho do novo sem eu ter de adivinhar qual e qual.
   */
  async reencontrarPorta(mod, ms) {
    try { if (this.transporte) await this.transporte.disconnect(); } catch (e) {}
    this.transporte = null;

    var candidatas = [];
    var anotar = (p) => { if (p && candidatas.indexOf(p) === -1) candidatas.push(p); };
    var aoConectar = (e) => anotar(e.target || e.port);
    try { SERIAL.addEventListener('connect', aoConectar); } catch (e) {}

    var fim = Date.now() + ms;
    try {
      while (Date.now() < fim) {
        await new Promise((r) => setTimeout(r, 400));
        try { (await SERIAL.getPorts()).forEach(anotar); } catch (e) {}

        for (var i = 0; i < candidatas.length; i++) {
          try {
            var t = new mod.Transport(candidatas[i], true);
            await t.connect(115200);
            this.porta = candidatas[i];
            this.transporte = t;
            return true;
          } catch (e) { /* essa nao serve; tenta a proxima */ }
        }
      }
    } finally {
      try { SERIAL.removeEventListener('connect', aoConectar); } catch (e) {}
    }
    return false;
  }

  /* ESPERAR O TRACKER ACORDAR: PRIMEIRO A MARCA, DEPOIS O RELOGIO.
   *
   * A ordem e o que importa aqui, e eu a tinha invertido. O [SlimeVR] sai
   * cedo, logo no comeco do boot, e o firmware ainda leva uns dez segundos
   * depois disso ate aceitar comando. Contar os dez a partir da porta aberta
   * era comecar a contar antes da hora - o prazo vencia com o tracker ainda
   * subindo.
   *
   * Se a marca nao vier, sigo assim mesmo: mandar o comando e melhor que
   * travar a pagina esperando uma linha que talvez ja tenha passado. */
  async esperarBoot(total) {
    var limite = Date.now() + ESPERA_BOOT * 2;
    while (this.recebido.indexOf(MARCA_BOOT) === -1 && Date.now() < limite) {
      await new Promise((r) => setTimeout(r, 150));
    }

    var comecou = Date.now();
    var fim = comecou + ESPERA_BOOT;
    while (Date.now() < fim) {
      this.progresso(Date.now() - comecou, total);
      await new Promise((r) => setTimeout(r, 150));
    }
  }

  /* `esperar` e falso quando a pessoa reabre a porta a mao: ali o tracker ja
     subiu ha muito, e cobrar mais dez segundos seria so espera. */
  async mandarWifi(esperar) {
    this.etapa('wifi');
    /* Uma barra so para os dois tempos: fingir duas seria contar a mesma
       espera duas vezes. */
    var inicio = esperar ? ESPERA_BOOT : 0;
    var total = inicio + 6600;
    this.progresso(0, total);
    this.dizer(this.d.msgWifi);

    /* O console ja liga aqui, e nao so pela resposta do WiFi: e durante esta
       espera que o tracker imprime o boot, que e o que a pessoa quer ver. */
    this.ouvirPorta();
    if (esperar) await this.esperarBoot(total);

    var marca = this.recebido.length;

    /* As aspas sao do comando, e nao enfeite: sem elas um nome de rede com
       espaco vira dois argumentos e o tracker guarda so o primeiro pedaco. */
    var cmd = 'SET WIFI "' + this.ssid.value.trim() + '" "' +
              (this.senha ? this.senha.value : '') + '"' + String.fromCharCode(10);
    await this.escreverLinha(cmd);

    /* A barra aqui nao mede bytes, mede espera: o comando e curto e o que
       demora e o tracker responder. Andar ate 90% e parar no OK e honesto
       sobre isso — fingir porcentagem de bytes seria inventar. */
    var fim = Date.now() + 6000;
    var ok = false;
    while (Date.now() < fim) {
      this.progresso(inicio + 6000 - (fim - Date.now()), total);
      /* Procurar "wifi" na resposta e frouxo de proposito: eu nao vi a
         mensagem exata que esta versao do firmware devolve, e cravar um texto
         que nao existe daria "talvez" para sempre. O console ao lado mostra a
         resposta crua, que e a prova de verdade. */
      if (this.recebido.slice(marca).toLowerCase().indexOf('wifi') !== -1) { ok = true; break; }
      await new Promise((r) => setTimeout(r, 150));
    }
    this.progresso(total, total);
    /* SO AQUI. No fim da gravacao o trabalho continua - ele volta a correr no
       passo do WiFi. Comemorar antes seria festejar no meio do caminho. */
    if (this.mascote) this.mascote.classList.add('is-vitoria');
    this.dizer(ok ? this.d.msgWifiOk : this.d.msgWifiTalvez);
  }

  /* O CONSOLE DEPOIS DA GRAVACAO, e a unica prova visivel de que deu certo.
   *
   * `rawRead` e um GERADOR assincrono, e nao uma promessa de um pedaco. Eu o
   * chamava com `await` e guardava o proprio gerador achando que era bytes -
   * dai o `decode` explodia, o catch engolia, e a leitura morria na primeira
   * volta. Era por isso que nada aparecia depois do "Leaving...": nao faltava
   * porta nem reinicio, faltava alguem lendo.
   *
   * O LEITOR E UM SO. Dois `for await` no mesmo gerador brigariam pelos mesmos
   * bytes, entao quem precisa de resposta - o passo do WiFi, a linha de
   * comando - olha o que este aqui ja acumulou em `recebido`. */
  async ouvirPorta() {
    if (this.lendo) return;
    this.lendo = true;
    this.recebido = '';
    var dec = new TextDecoder();
    try {
      for await (var p of this.transporte.rawRead()) {
        if (!this.lendo) break;
        var txt = dec.decode(p, { stream: true });
        this.recebido += txt;
        this.escrever(txt);

        /* Quem ve essa linha se repetindo acha que travou. Ela e boa noticia:
           o tracker ja esta na rede e so falta o SlimeVR Server abrir. */
        if (this.procurando && this.procurando.hidden &&
            this.d.marcaProcurando &&
            this.recebido.indexOf(this.d.marcaProcurando) !== -1) {
          this.procurando.hidden = false;
        }

        /* O FIM E ANUNCIADO NA BARRA, que e onde a pessoa vinha lendo o
           andamento. Cravar 100% junto importa: a barra parada a 90% ao lado da
           frase "concluida" seria a tela se contradizendo. */
        if (this.d.marcaConectado && this.d.msgConcluido && !this.acabou &&
            this.recebido.indexOf(this.d.marcaConectado) !== -1) {
          this.acabou = true;
          this.progresso(1, 1);
          this.dizer(this.d.msgConcluido);
        }
      }
    } catch (e) { /* porta fechada encerra a leitura */ }
    this.lendo = false;
  }

  async mandarComando() {
    if (!this.linha || !this.transporte) return;
    var txt = this.linha.value.trim();
    if (!txt) return;
    this.escrever('> ' + txt + '\n');
    try {
      await this.escreverLinha(txt + String.fromCharCode(10));
      this.linha.value = '';
    } catch (e) {
      this.escrever((this.d.msgErro || 'Erro') + '\n');
    }
  }

  async desligar() {
    this.lendo = false;
    try { if (this.transporte) await this.transporte.disconnect(); } catch (e) {}
    this.transporte = null;
    this.loader = null;
    this.porta = null;
  }

  /* O firmware ja esta gravado; falta so mandar a rede. Pede a porta de novo,
     que agora e a do tracker ja rodando o firmware novo. */
  async continuarWifi() {
    /* Mesma ordem do `instalar`: o gesto primeiro, o download depois. */
    try {
      this.porta = await SERIAL.requestPort();
    } catch (e) { return; }
    var mod;
    try { mod = await import(CDN); } catch (e) { this.dizer(this.d.msgSemBiblioteca); return; }
    try {
      this.transporte = new mod.Transport(this.porta, true);
      await this.transporte.connect(115200);
      await this.mandarWifi(false);
      this.etapa('console');
      this.ouvirPorta();
    } catch (e) {
      this.falhar(e);
    }
  }

  async proximoTracker() {
    await this.desligar();
    if (this.console) this.console.textContent = '';
    /* O proximo tracker comeca do zero, inclusive o "ja acabou": sem isto o
       recado de concluida do anterior valeria para ele. */
    this.acabou = false;
    this.procurando && (this.procurando.hidden = true);
    this.mascote && this.mascote.classList.remove('is-vitoria');
    this.progresso(0, 1);
    this.dizer('');
    this.etapa('escolher');
    this.instalar();
  }
}

function ligar() {
  document.querySelectorAll('[data-nt-instalador]').forEach(function (raiz) {
    if (raiz.dataset.ntPronto) return;
    raiz.dataset.ntPronto = '1';
    new Instalador(raiz);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ligar, { once: true });
} else {
  ligar();
}
document.addEventListener('shopify:section:load', ligar);
